import styled from 'styled-components';
import { Scrollbar } from '@ann/web-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-x: hidden;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px;
  height: 36px;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.ghostWhite};
  }
`;

export const ArrowWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const List = styled(Scrollbar).attrs({ size: "small", display: "flex" })`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 264px;
  overscroll-behavior: none;
  overscroll-behavior-y: none;

  & > * {
    overscroll-behavior: none;
    overscroll-behavior-y: none;
  }
`;

export const ListItem = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  padding: 8px;
  height: 36px;
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  min-width: 0;

  ${(props) =>
    !props.$isSelected &&
    `
    &:hover {
      background-color: ${props.theme.colors.ghostWhite};
      border-radius: 8px;
    }
  `}

  ${(props) =>
    props.$isSelected &&
    `
    background-color: ${props.theme.colors.titanWhite};
    border-radius: 8px;
  `}
`;

/** Typography from @ann/web-components renders a span; ellipsis on that span. */
export const AgentNameWrap = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;

  /* Aplicar ellipsis al span del Typography */
  & > span {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
